import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import { Button } from '../../common'

import {
	getEmail,
	getIsOnlyLegalFlow,
	getUserId,
} from '../../../redux/slices/userSlice'
import { ampEvent } from '../../../utils/amplitude'
import { paramsToQuery } from '../../../utils/historyDecorators'

import './styles.scss'

const AuthorizedUser = ({ formEmail }) => {
	const history = useHistory()
	const user_id = useSelector(getUserId)
	const email = useSelector(getEmail)
	const isOnlyLegalFlow = useSelector(getIsOnlyLegalFlow)

	const cancelSubscription = () => {
		setTimeout(() => {
			ampEvent('start_cancel_subscription')
		}, 0)
		if (isOnlyLegalFlow) {
			history.push({
				pathname: `/unsubscribe/reason`,
				search: paramsToQuery({
					email: formEmail || email,
					user_id,
					external_id: user_id,
				}),
			})
		} else {
			window.open(
				'https://mail.google.com/mail/u/0/?fs=1&to=support@refineapp.co&tf=cm',
				'_blank',
			)
		}
	}

	return (
		<div className="authorized-user">
			<p className="authorized-user__title">Subscription</p>
			<p className="authorized-user__cancel">
				Your subscription is active but you may cancel it
			</p>
			<Button buttonText="Cancel subscription" onClick={cancelSubscription} />
		</div>
	)
}

export { AuthorizedUser }
